// src/pages/AccesoDenegado.js
import React from "react";
import { Link } from "react-router-dom";

const AccesoDenegado = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-xl text-center bg-white p-8 rounded shadow">
        <h1 className="text-3xl font-bold mb-4">Acceso denegado</h1>
        <p className="mb-6">No tienes permisos para ver esta sección.</p>
        <Link to="/" className="bg-blue-600 text-white px-4 py-2 rounded">
          Volver al inicio
        </Link>
      </div>
    </div>
  );
};

export default AccesoDenegado;
